import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatService } from 'src/app/core/chat.service';
import { FlashcardService } from 'src/app/core/flashcard.service';
import { Flashcard } from 'src/app/models/flashcard.model';
import { SharedModule } from '../shared.module';
import { ControlsModule } from 'src/app/controls/controls.module';

@Component({
  selector: 'app-ai-chat',
  templateUrl: './ai-chat.component.html',
  styleUrls: ['./ai-chat.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ControlsModule,
    SharedModule
  ]
})
export class AiChatComponent {

  messages: { sender: 'user' | 'ai', content: string, pending: boolean }[] = [];
  text: string = '';
  learnsetId?: number;
  sessionId?: number;
  generatingFlashcards: boolean = false;
  flashcards: Flashcard[] = [];
  showFlashcards: boolean = false;
  isSavingFlashcards: boolean = false;

  constructor(private chatService: ChatService, private route: ActivatedRoute, private flashcardService: FlashcardService, private router: Router) {}

  ngOnInit() {
    this.learnsetId = Number(this.route.snapshot.paramMap.get('id')!);
    this.initSession();
    this.messages.push({ sender: 'ai', content: 'Hi, Wie kann ich dir helfen? 😉', pending: false });
  }

  initSession() {
    this.chatService.initSimpleChatSession().subscribe((result) => this.sessionId = result.sessionId);
  }

  handleSend() {
    if (this.flashcards?.length > 0) {
      this.flashcards = [];
    }
    this.messages.push({ sender: 'user', content: this.text.toString(), pending: false });
    setTimeout(() => {
      this.messages.push({ sender: 'ai', content: '...', pending: true });
    }, 1000);
    this.chatService.postSimpleChatMessage(this.sessionId!, this.text).subscribe((result) => {
      this.messages.pop();
      this.messages.push({ sender: 'ai', content: result.response, pending: false });
    });
    this.text = '';
  }

  displayFlashcards() {
    this.showFlashcards = true;
  }
}
